import moment from 'moment-jalaali';

/** آیا پیگیری با do_now ثبت شده است؟ */
export function isDoNowFollowUp(followUp) {
  return (
    followUp?.do_now === true ||
    followUp?.do_now === 1 ||
    followUp?.do_now === '1'
  );
}

/** آیا پیگیری فوری/بدون تاریخ بعدی است؟ */
export function isImmediateFollowUp(followUp) {
  return isDoNowFollowUp(followUp) || !followUp?.next_follow_up_date;
}

/** وضعیت نمایشی پیگیری */
export function resolveFollowUpStatus(followUp) {
  if (followUp?.status === 'completed' || followUp?.status === 'done') return 'completed';
  if (followUp?.status === 'canceled' || followUp?.status === 'cancelled') return 'canceled';
  if (followUp?.status === 'pending') return 'pending';
  if (isImmediateFollowUp(followUp) && followUp?.remark) return 'completed';
  return 'pending';
}

export const FOLLOW_UP_STATUS_OPTIONS = [
  { value: 'pending', label: 'در انتظار' },
  { value: 'completed', label: 'انجام شده' },
  { value: 'canceled', label: 'لغو شده' },
];

/** نگاشت status دریافتی از API به مقدار Select فرم */
export const normalizeFollowUpStatusForForm = (status) => {
  if (!status) return 'pending';
  if (status === 'done' || status === 'completed') return 'completed';
  if (status === 'cancelled') return 'canceled';
  if (status === 'pending' || status === 'canceled') return status;
  return 'pending';
};

export function getFollowUpStatusLabel(status) {
  if (status === 'completed') return 'انجام شده';
  if (status === 'canceled') return 'لغو شده';
  return 'در انتظار';
}

export function getFollowUpStatusTagColor(status) {
  if (status === 'completed') return 'green';
  if (status === 'canceled') return 'default';
  return 'orange';
}

/** متن/تاریخ پیگیری انجام‌شده — line-through با متن خوانا در تم تاریک */
export const COMPLETED_FOLLOWUP_DATE_CLASS =
  'font-semibold text-sm line-through decoration-1 text-gray-400 dark:text-gray-300 decoration-gray-400 dark:decoration-gray-500';

export const COMPLETED_FOLLOWUP_TEXT_CLASS =
  'line-through decoration-1 text-gray-500 dark:text-gray-300 decoration-gray-400 dark:decoration-gray-500';

/** آیا پیگیری پس از ایجاد ویرایش شده است؟ */
export function isFollowUpEdited(followUp) {
  const createdAt = followUp?.created_at;
  const updatedAt = followUp?.updated_at;
  if (!updatedAt || !createdAt) return false;

  const created = moment(createdAt);
  const updated = moment(updatedAt);
  if (created.isValid() && updated.isValid()) {
    return !created.isSame(updated, 'second');
  }
  return String(createdAt).trim() !== String(updatedAt).trim();
}

/** فرمت تاریخ/زمان پیگیری برای نمایش */
export function formatFollowUpDateTime(dateString) {
  if (!dateString) return null;
  try {
    const date = moment(dateString);
    if (!date.isValid()) return null;
    return date.format('jYYYY/jMM/jDD HH:mm');
  } catch {
    return null;
  }
}

/** زمان انجام فعالیت — فقط وقتی وضعیت انجام‌شده باشد، از updated_at */
export function resolveFollowUpCompletedAt(followUp) {
  if (resolveFollowUpStatus(followUp) !== 'completed') return null;
  return (
    formatFollowUpDateTime(followUp?.updated_at)
    || formatFollowUpDateTime(followUp?.created_at)
  );
}

/** نمایش تاریخ پیگیری به‌صورت نسبی (امروز، دیروز، ...) */
export function formatRelativeFollowUpDate(dateString) {
  if (!dateString) return null;
  try {
    const date = moment(dateString);
    if (!date.isValid()) return null;

    const target = date.clone().startOf('day');
    const today = moment().startOf('day');
    const diffDays = target.diff(today, 'days');

    if (diffDays === 0) return 'امروز';
    if (diffDays === 1) return 'فردا';
    if (diffDays === -1) return 'دیروز';
    if (diffDays === -3) return 'سه روز قبل';
    if (diffDays <= -4 && diffDays >= -10) return 'هفته پیش';
    if (diffDays <= -11 && diffDays >= -45) return 'یکماه گذشته';
    if (diffDays <= -46) return 'یکسال گذشته';

    return date.format('jYYYY/jMM/jDD');
  } catch {
    return null;
  }
}

/** برچسب نمایشی پیگیری: نسبی + تاریخ کامل در صورت نیاز */
export function formatFollowUpDisplayLabel(dateString) {
  const relative = formatRelativeFollowUpDate(dateString);
  const absolute = formatFollowUpDateTime(dateString);
  if (!relative && !absolute) return null;
  if (relative && ['امروز', 'دیروز', 'فردا', 'سه روز قبل', 'هفته پیش', 'یکماه گذشته', 'یکسال گذشته'].includes(relative)) {
    return relative;
  }
  return absolute || relative;
}
